import { postCreateBusinessTag } from "apis";
import { useCallback } from "react";
import usePostToggleTagForAppointment from "../../apis/tryst/toggle-tag";
import { AptTagsPanelProps, TagFormPropsType } from "../../types/appointment";
import { CellRendererProps } from "../../utils/get-billing-queue-col-defs";
import MinimizedTags from "../appointments/autosized-tags";
import { useMyAccessProfileV2 } from "../../apis/tryst/get-my-access-profile";

export function TagsCellRenderer({ data: receiptEntity }: CellRendererProps) {
  const { data: myAccessProfile } = useMyAccessProfileV2();

  const { mutateAsync: postToggleTag } = usePostToggleTagForAppointment();

  const onToggleTag = useCallback<AptTagsPanelProps["onTagClick"]>(
    async ({ aid, tagId }) => {
      postToggleTag({ business_id: myAccessProfile?.business.id!, tagId, aid });
    },
    [myAccessProfile?.business?.id, postToggleTag]
  );

  const onTagCreation = useCallback<TagFormPropsType["onAdditionOfTag"]>(
    async ({ tagRecord, aid }) => {
      const createTagResponse = await postCreateBusinessTag({
        businessId: myAccessProfile?.business.id!,
        tagRecord: tagRecord,
      });

      const { data } = createTagResponse;

      if (aid && data) {
        postToggleTag({
          business_id: myAccessProfile?.business.id!,
          tagId: data.tag_id,
          aid,
        });
      }
      return createTagResponse;
    },
    [myAccessProfile?.business.id, postToggleTag]
  );

  if (!receiptEntity) {
    return <></>;
  }

  return (
    <div className="w-full h-full flex items-center overflow-x-hidden">
      <MinimizedTags
        filteredTags={new Set()}
        allTagIds={receiptEntity?.tags || []}
        aid={receiptEntity.aid}
        onTagClick={onToggleTag}
        onTagCreation={onTagCreation}
      />
    </div>
  );
}
